import { render, staticRenderFns } from "./PayoutErrorCountTile.vue?vue&type=template&id=bb795970&"
import script from "./PayoutErrorCountTile.vue?vue&type=script&lang=js&"
export * from "./PayoutErrorCountTile.vue?vue&type=script&lang=js&"
import style0 from "./PayoutErrorCountTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports